import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const LiveNotifyDialog = (props) => {
    const { open, notification, onClose } = props;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="lg"
            PaperProps={{ style: { background: 'white' } }}
        >
            <DialogTitle>
                <strong>{notification?.title || 'Notification'}</strong>
            </DialogTitle>
            <DialogContent dividers>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <div
                        style={{ width: '100%', maxWidth: '960px', lineHeight: 1.6, wordBreak: 'break-word' }}
                        dangerouslySetInnerHTML={{ __html: notification?.message || '' }}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LiveNotifyDialog;
